import Image from 'app/Components/Shared/Image/image';
import React, {useState} from 'react';
import PopUp from '../../../Shared/Popup/PopUp';
import BtnSubmit from 'app/Components/Shared/Buttons/BtnSubmit';
import Config from 'app/Config';
import EpiContext from '@episerver/spa-core/Spa';
import {clearHistory} from '../IdfSaleSlice';
import {connect} from 'react-redux';
import {isNullOrEmpty} from 'app/utilities/StringHelpers/StringHelpers';
import {dwhReport, dwhDictionary} from './../dwhReports/dwhGeneralReport';
function OrderSummarySucceededButton({store, clearHistory}) {
  const [showPopup, setShowPopUp] = useState(false);

  const handleFinalSubmit = () => {
    EpiContext.navigateTo(Config.idfHomePageUrl);
    setShowPopUp(false);
    clearHistory();
  };
  const sapOrderNo = store.userDetails.sap_order_no;
  const EsimSapOrderNo = store.userDetails.esim_sap_order_no;
  const isOrderWithEsim = !isNullOrEmpty(EsimSapOrderNo);
  const orderNoText1 = !isNullOrEmpty(sapOrderNo) && isOrderWithEsim ? 'מס הזמנה עבור מכשיר' : 'מס הזמנה';
  const esimText = 'מס הזמנה עבור Esim:';
  const dwh = () => {
    dwhReport({
      ...dwhDictionary.OrderSummary_Completed,
      param4: store.isLeasing,
      param5: store.simType,
      param6: store.processType == 'DEVICE' ? 'עם מכשיר' : 'ללא מכשיר',
      param7: store.deliveryMode,
      param8: store.deliveryMode == 'PICKUP' ? store.pickupDate : store.selectedDeliverySlot.deliveryStartTime,
      param9: `${orderNoText1} ${sapOrderNo} , ${isOrderWithEsim && esimText + EsimSapOrderNo} `,
      param10: store?.selectedEmail,
    });
  };

  return (
    <>
      <div className='OrderSummarySucceededButton'>
        <BtnSubmit
          text={'סיום'}
          onclick={() => {
            dwh();
            setShowPopUp(true);
          }}
        />
      </div>

      <PopUp className='Order-Summary-Succeeded-popup' preventWrapperClose={true} showPopUp={showPopup} onClose={() => setShowPopUp(false)}>
        <>
          <Image src={require('../icon/success.svg')} width='120' height='120' />
          <div className='title'>ההזמנה בוצעה בהצלחה</div>
          {!isNullOrEmpty(sapOrderNo) && (
            <div className='sub-title'>
              {orderNoText1} :<br /> {sapOrderNo}
            </div>
          )}
          {isOrderWithEsim && (
            <div className='sub-title'>
              {esimText}
              <br /> {EsimSapOrderNo}
            </div>
          )}
          <BtnSubmit text='סיום' onclick={() => handleFinalSubmit()} />
        </>
      </PopUp>
    </>
  );
}

const mapStateToProps = (state) => ({
  store: state.idfSale,
});

const mapDispatchToProps = {
  clearHistory,
};

export default connect(mapStateToProps, mapDispatchToProps)(OrderSummarySucceededButton);
